import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api_url } from "../config/config";
import { Helmet } from "react-helmet";
import Upload from "../Pages/Upload";
import ArticleCarousel from "../Components/common/Blogs/BlogCarousal";
import cbg1 from "../images/cnbg/cnbg1.svg";
import cbg2 from "../images/cnbg/cnbg2.svg";
import cbg3 from "../images/cnbg/cnbg3.svg";
import cbg4 from "../images/cnbg/cnbg4.svg";
import cbg5 from "../images/cnbg/cnbg5.svg";
import cbg6 from "../images/cnbg/cnbg6.svg";
import cbg7 from "../images/cnbg/cnbg7.svg";
import cbg8 from "../images/cnbg/cnbg8.svg";
import HeroSection from "../Components/HeroSection";
import ShopByBrand from "../Components/Home/ShopByBrand";
import FeaturedProduct_home from "../Components/Home/FeaturedProduct_home";
import Shopbyconcern from "../Components/Home/Shopbyconcern";
import AllProducts_home from "../Components/Home/AllProducts_home";
import { useNavigate } from "react-router-dom";
import { toProductSlug } from "../utils/productSlug";
import vector1 from "../images/aboutimages/Vector (1).png";
import vector2 from "../images/aboutimages/Vector.png";
import vector3 from "../images/aboutimages/Group (1).png";
import Popup from "../Components/common/Popup";
import { useApp } from "../Context/AppContext";
import { getRecentlyViewed } from "../utils/recentlyViewed";

const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

const backgroundImagesConcern = [
  cbg1,
  cbg2,
  cbg8,
  cbg4,
  cbg5,
  cbg6,
  cbg7,
  cbg3,
];

const HomePage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [recentlyViewed] = useState(() => getRecentlyViewed());

  const limit = 12;

  const {
    contextHeroImages,
    contextCategories,
    contextBrands,
    contextConcerns,
  } = useApp();
  const navigate = useNavigate();

  /* ── Scroll + section restore ── */
  useEffect(() => {
    const section = sessionStorage.getItem("scrollToSection");
    if (section) {
      let attempts = 0;
      const id = setInterval(() => {
        const el = document.getElementById(section);
        if (el || attempts > 20) {
          if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
          sessionStorage.removeItem("scrollToSection");
          clearInterval(id);
        }
        attempts++;
      }, 300);
      return () => clearInterval(id);
    }
    window.scrollTo(0, 0);
  }, []);

  /* ── Hero auto-slide ── */
  useEffect(() => {
    const interval = setInterval(() => {
      setCarouselIndex((prev) =>
        prev === contextHeroImages.length - 1 ? 0 : prev + 1,
      );
    }, 9000);
    return () => clearInterval(interval);
  }, [contextHeroImages.length]);

  /* ── Fetch products ── */
  const fetchAllProducts = async (currentPage) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${api_url}/products?page=${currentPage}&limit=${limit}`,
        {
          headers: { "Content-Type": "application/json", "x-auth": "false" },
        },
      );
      const data = await response.json();
      if (data?.results) {
        setProducts((prev) =>
          currentPage === 1 ? data.results : [...prev, ...data.results],
        );
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAllProducts(page);
  }, [page]);

  /* ── Navigation handlers ── */
  const handleclikforcategory = (category_id, category_name) => {
    navigate("/categories", {
      state: { category_id, category_name },
    });
  };
  const handleclickforfeaturedproduct = (product_id, product) => {
    navigate(`/products/${toProductSlug(product)}`, {
      state: { product_id },
    });
  };
  const handleclikforconcern = (concern_id, concern_name) => {
    navigate(
      `/shop-by-concern/${concern_name?.toLowerCase().replace(/\s+/g, "-")}`,
      { state: { concern_id, concern_name } },
    );
  };

  /* ── Section heading component ── */
  const SectionHeading = ({ label, title, subtitle, viewAllTo }) => (
    <div className="flex items-end justify-between mb-6 sm:mb-8">
      <div>
        <div className="flex items-center gap-2 mb-1.5">
          <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
          <span className="text-[10px] sm:text-[11px] font-bold uppercase tracking-widest text-[#ff601e] font-poppins">
            {label}
          </span>
        </div>
        <h2 className="font-bold text-[20px] sm:text-[24px] lg:text-[28px] text-[#1e4a46] font-poppins leading-tight">
          {title}
        </h2>
        {subtitle && (
          <p className="text-[13px] text-[#8faba9] mt-1 hidden sm:block font-poppins">
            {subtitle}
          </p>
        )}
      </div>
      {viewAllTo && (
        <Link to={viewAllTo}>
          <button className="flex items-center gap-1.5 bg-[#162c2a] hover:bg-[#ff601e] text-white font-poppins font-semibold text-[11px] sm:text-[12px] px-4 h-8 rounded-xl transition-all duration-200 shadow-[0_2px_8px_rgba(22,44,42,0.25)] hover:shadow-[0_4px_14px_rgba(255,96,30,0.4)] hover:-translate-y-0.5 whitespace-nowrap">
            View All
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </Link>
      )}
    </div>
  );

  return (
    <>
      <Helmet>
        <title>
          Online Medical Store, Online Medicine Order, Fastest Delivery |
          MediSYS Pharmacy
        </title>
        <meta
          name="description"
          content="MediSYS Pharmacy Online Medical Store - Buy medicines online and experience fastest home delivery."
        />
        <meta
          name="keywords"
          content="pharmacy, medical stores, online pharmacy, online pharmacy India, best online pharmacy, online pharmacy hyderabad, online medical store"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Online Medical Store | MediSYS Pharmacy"
        />
        <meta
          property="og:description"
          content="Buy medicines online from MediSYS Pharmacy and experience fastest home delivery."
        />
      </Helmet>
      {/* ══════════════════════════════════════
          HERO SECTION
      ══════════════════════════════════════ */}
      <div className="w-full overflow-hidden ">
        <HeroSection apiHerosImage={contextHeroImages} />
      </div>
      {/* ══════════════════════════════════════
          TRUST STRIP
      ══════════════════════════════════════ */}
      {/* <div className="w-full px-4 sm:px-6 lg:px-6 xl:px-6 pt-6 sm:pt-8 font-poppins">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
          {[
            {
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              ),
              text: "Licensed Pharmacy · GSTIN: 36ABTFM9976H1Z7",
            },
            {
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              ),
              text: "100% Genuine · Verified Medicines",
            },
            {
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              ),
              text: "Pharmacist-Verified Prescriptions",
            },
          ].map((b, i) => (
            <div
              key={i}
              className="flex items-center gap-3 bg-white border border-[#e2eaea] rounded-2xl px-4 py-3 shadow-[0_2px_10px_rgba(22,44,42,0.06)]"
            >
              <span className="flex-shrink-0 w-9 h-9 rounded-xl bg-[#eaf4f3] border border-[#c5d5d4] flex items-center justify-center">
                {b.icon}
              </span>
              <span className="text-[12px] sm:text-[13px] font-semibold text-[#1e4a46] leading-snug">
                {b.text}
              </span>
            </div>
          ))}
        </div>
      </div> */}
      {/* ══════════════════════════════════════
          FEATURED PRODUCTS
      ══════════════════════════════════════ */}
      <FeaturedProduct_home />
      {/* ══════════════════════════════════════
          SHOP BY CATEGORIES
      ══════════════════════════════════════ */}
      {contextCategories?.length > 0 && (
        <section className="w-full py-8 sm:py-6 lg:py-6 px-4 sm:px-6 lg:px-6 xl:px-6 font-poppins bg-[#f8fafa]">
          <SectionHeading
            label="Browse"
            title="Shop by Categories"
            subtitle="Find medicines, devices & wellness products by category"
            viewAllTo="/Categories"
          />

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 sm:gap-4 lg:gap-5 max-h-[352px] sm:max-h-[396px] md:max-h-[436px] lg:max-h-[460px] overflow-hidden">
            {contextCategories.map((item, index) => {
              const isOrange = index % 2 === 1;
              const cardBg = isOrange
                ? "bg-gradient-to-b from-[#fff3ee] to-white"
                : "bg-gradient-to-b from-[#eaf4f3] to-white";
              const cardBorder = isOrange
                ? "border-[#ffd5c2] hover:border-[#ff601e]"
                : "border-[#c5d5d4] hover:border-[#5fbdb3]";
              const accentBar = isOrange
                ? "from-[#ff601e] to-[#e55519]"
                : "from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]";
              const imgRing = isOrange
                ? "bg-[#ffd5c2]/40 border-[#ffd5c2]"
                : "bg-[#d4ecea]/50 border-[#c5d5d4]";
              const nameColor = isOrange
                ? "text-[#c44a14] group-hover:text-[#ff601e]"
                : "text-[#1e4a46] group-hover:text-[#3a7a74]";
              const nameStrip = isOrange
                ? "border-[#ffd5c2]/50 bg-[#fff8f5]/90"
                : "border-[#d4ecea]/50 bg-[#f4fbfa]/90";
              const cardShadow = isOrange
                ? "shadow-[0_2px_12px_rgba(255,96,30,0.09)] hover:shadow-[0_10px_28px_rgba(255,96,30,0.22)]"
                : "shadow-[0_2px_12px_rgba(95,189,179,0.10)] hover:shadow-[0_10px_28px_rgba(95,189,179,0.22)]";

              return (
                <button
                  key={index}
                  onClick={() =>
                    handleclikforcategory(item.category_id, item.category_name)
                  }
                  className={`group relative flex flex-col items-center justify-end rounded-2xl overflow-hidden
                  h-[170px] sm:h-[190px] md:h-[210px] lg:h-[220px]
                  border-[1.5px] ${cardBorder} ${cardBg} ${cardShadow}
                  hover:-translate-y-2 transition-all duration-300 cursor-pointer`}
                  style={{
                    animation: `fadeInUp 0.35s ease ${index * 35}ms both`,
                  }}
                >
                  {/* Top accent bar */}
                  <div
                    className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r ${accentBar} opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`}
                  />

                  {/* Corner dot */}
                  <div
                    className={`absolute top-2.5 right-2.5 w-2 h-2 rounded-full ${isOrange ? "bg-[#ff601e]" : "bg-[#5fbdb3]"}
                  opacity-25 group-hover:opacity-70 group-hover:scale-125 transition-all duration-300 z-10`}
                  />

                  {/* Image ring */}
                  <div className="absolute inset-0 flex items-center justify-center pb-10">
                    <div
                      className={`w-[80px] h-[80px] sm:w-[95px] sm:h-[95px] md:w-[150px] md:h-[150px]
                    rounded-2xl ${imgRing} border flex items-center justify-center overflow-hidden
                    group-hover:scale-110 transition-transform duration-300`}
                    >
                      <img
                        src={item.image_url || "/default.svg"}
                        alt={item.category_name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/default.svg";
                        }}
                        className="w-full h-full p-2 object-contain"
                      />
                    </div>
                  </div>

                  {/* Name strip */}
                  <div
                    className={`relative w-full py-2.5 px-2 text-center border-t ${nameStrip}`}
                  >
                    <p
                      className={`font-semibold text-[11px] sm:text-[12px] md:text-[13px] leading-snug line-clamp-2 transition-colors duration-200 ${nameColor}`}
                    >
                      {item.category_name}
                    </p>
                  </div>
                </button>
              );
            })}
          </div>
        </section>
      )}
      {/* ══════════════════════════════════════
          SHOP BY BRAND
      ══════════════════════════════════════ */}
      {contextBrands?.length > 0 && <ShopByBrand />}{" "}
      {/* ══════════════════════════════════════
          SHOP BY CONCERN
      ══════════════════════════════════════ */}
      {contextConcerns?.length > 0 && (
        <Shopbyconcern
          apiConcern={contextConcerns}
          handleclikforconcern={handleclikforconcern}
          backgroundImagesConcern={backgroundImagesConcern}
        />
      )}
      {/* ══════════════════════════════════════
          RECENTLY VIEWED
      ══════════════════════════════════════ */}
      {recentlyViewed.length > 0 && (
        <section className="w-full py-6 sm:py-6 px-4 sm:px-6 lg:px-6 xl:px-6 font-poppins bg-[#f8fafa]">
          <SectionHeading label="Continue Browsing" title="Recently Viewed" />
          <div className="flex gap-3 sm:gap-4 scrollbar-hide overflow-x-auto pt-2 pb-4 -mx-1 px-1">
            {recentlyViewed.map((item) => (
              <div
                key={item.product_id}
                onClick={() =>
                  handleclickforfeaturedproduct(item.product_id, item)
                }
                className="group flex-shrink-0 w-[140px] sm:w-[160px] bg-white border-[1.5px] border-[#e2eaea] hover:border-[#5fbdb3] rounded-2xl overflow-hidden shadow-[0_2px_10px_rgba(22,44,42,0.06)] hover:shadow-[0_8px_24px_rgba(22,44,42,0.12)] hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              >
                <div className="w-full h-[110px] sm:h-[130px] bg-[#f4fbfa] overflow-hidden p-2.5 flex items-center justify-center">
                  <img
                    src={item.image || "/default.svg"}
                    alt={item.name || "Product"}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/default.svg";
                    }}
                    className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="px-2.5 py-2">
                  <p className="font-semibold text-[11px] sm:text-[12px] text-[#1e4a46] line-clamp-2 leading-snug group-hover:text-[#ff601e] transition-colors">
                    {item.name || "Product"}
                  </p>
                  {item.mrp ? (
                    <p className="mt-1 font-bold text-[12px] sm:text-[13px] text-[#1e4a46]">
                      ₹{item.finalPrice}
                    </p>
                  ) : (
                    <p className="mt-1 text-[11px] text-[#8faba9] font-medium">
                      Price N/A
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
      {/* ══════════════════════════════════════
          UPLOAD PRESCRIPTION
      ══════════════════════════════════════ */}
      <Upload />
      {/* ══════════════════════════════════════
          ALL PRODUCTS
      ══════════════════════════════════════ */}
      {products?.length > 0 && (
        <AllProducts_home
          products={products}
          handleclickforfeaturedproduct={handleclickforfeaturedproduct}
        />
      )}
      {/* ══════════════════════════════════════
          WHY CHOOSE US
      ══════════════════════════════════════ */}
      {/* ══════════════════════════════════════
          ARTICLE CAROUSEL
      ══════════════════════════════════════ */}
      <div id="article-section" className="w-full">
        <ArticleCarousel />
      </div>
      <section className="relative overflow-hidden py-10 sm:py-14 lg:py-16 px-4 sm:px-8 lg:px-14 font-poppins">
        {/* Teal-dark bg with plus pattern */}
        <div className="absolute inset-0 bg-[#162c2a]" />
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: plusPattern,
            backgroundRepeat: "repeat",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute -top-16 right-0 w-72 h-72 rounded-full bg-[#5fbdb3]/10 blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-[#ff601e]/8 blur-3xl pointer-events-none" />

        <div className="relative">
          {/* Section label */}
          <div className="text-center mb-10 sm:mb-12">
            <div className="flex items-center justify-center gap-3 mb-3">
              <span className="w-7 h-[2px] bg-[#ff601e] rounded-full" />
              <span className="text-[11px] font-bold uppercase tracking-widest text-[#5fbdb3]">
                Our Impact
              </span>
              <span className="w-7 h-[2px] bg-[#ff601e] rounded-full" />
            </div>
            <h2 className="font-bold text-[22px] sm:text-[28px] lg:text-[34px] text-white leading-tight">
              Why Choose <span className="text-[#5fbdb3]">MediSYS?</span>
            </h2>
            <p className="text-[13px] text-white/50 mt-2 max-w-[400px] mx-auto">
              Trusted by thousands of patients across Hyderabad
            </p>
          </div>

          {/* Stat cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
            {[
              {
                img: vector3,
                alt: "Offline Stores",
                number: "100+",
                label: "Offline Stores",
                bar: "from-[#ff601e] to-[#e55519]",
                iconBg: "bg-[#fff3ee]",
                numColor: "text-[#ff601e]",
              },
              {
                img: vector2,
                alt: "Pincodes Served",
                number: "2000+",
                label: "Pincodes Served",
                bar: "from-[#1e4a46] to-[#5fbdb3]",
                iconBg: "bg-[#eaf4f3]",
                numColor: "text-[#5fbdb3]",
              },
              {
                img: vector1,
                alt: "Happy Customers",
                number: "4360+",
                label: "Happy Customers",
                bar: "from-[#ff601e] to-[#e55519]",
                iconBg: "bg-[#fff3ee]",
                numColor: "text-[#ff601e]",
              },
            ].map((s, i) => (
              <div
                key={i}
                className="group relative bg-white/[0.06] border border-white/[0.1] backdrop-blur-sm rounded-2xl p-6 sm:p-7 flex items-center gap-5 hover:bg-white/[0.1] hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                {/* Top gradient accent */}
                <div
                  className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r ${s.bar}`}
                />

                {/* Icon */}
                <div
                  className={`w-14 h-14 sm:w-16 sm:h-16 rounded-2xl ${s.iconBg} border border-white/10 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}
                >
                  <img
                    src={s.img}
                    alt={s.alt}
                    className="w-7 h-7 sm:w-9 sm:h-9 object-contain"
                  />
                </div>

                {/* Text */}
                <div>
                  <p
                    className={`font-bold text-[36px] sm:text-[42px] lg:text-[48px] leading-none ${s.numColor}`}
                  >
                    {s.number}
                  </p>
                  <p className="font-semibold text-[13px] sm:text-[14px] text-white/60 mt-1">
                    {s.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {showLoginPopup && <Popup onClose={() => setShowLoginPopup(false)} />}
    </>
  );
};

export default HomePage;
